<template>
    <div id="index">
      <v-header></v-header>
      <router-view/>
      <v-footer></v-footer>
    </div>
</template>

<script>
  import vHeader from "./public/header"
  import vFooter from "./public/footer"
  import vAside from "./public/aside"
    export default {
      name: "index",
      components:{vFooter,vHeader,vAside}
    }
</script>

<style scoped>
#index{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue